import supportModule from '../supportModule';

function ageGate(resources) {
  'ngInject';

  return {
    restrict: 'A',
    scope: true,
    replace: true,
    templateUrl: resources.templateUrls.ageGate
  };
}

supportModule.directive('ageGate', ageGate);

export default ageGate;